
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.visually-hidden{clip-path:inset(50%);height:1px;overflow:hidden;position:absolute!important;width:1px}ul{list-style-type:none;margin:0;padding:var(--spacing-0)}.list{display:flex;flex-wrap:wrap}.row{flex-direction:row}.col-center,.column{flex-direction:column}.col-center{align-items:center}`;